export default __webpack_public_path__ + "static/media/wish.26a693fd.svg";